/**
 * Official Punto Hispano credentials — single source of truth.
 * Displayed in TrustBar and other credibility surfaces above-the-fold.
 * Values verified from i18n copy (segurosPage.badge1 / badge2).
 */
export const CREDENTIALS = {
  cicero: {
    number: "31700",
    label: "CICERO",
    url: "https://www.cicero.ch/",
  },
  finma: {
    number: "F014686595",
    label: "FINMA",
    url: "https://www.finma.ch/",
  },
  foundedYear: 2013,
  swissLabel: "Swiss Made",
} as const;
